import React from "react";
import { Sparkles, Cpu, Building2, FlaskConical, Wrench, Bot, Cog, TrendingUp, Scale, ShieldCheck, GitBranch, Newspaper } from "lucide-react";
import { useI18n } from "@/i18n";

export const CATEGORY_ICONS = {
  "generative-ai": Sparkles,
  "ai-models": Cpu,
  "ai-companies": Building2,
  "ai-research": FlaskConical,
  "ai-tools": Wrench,
  "ai-agents": Bot,
  robotics: Cog,
  "ai-business": TrendingUp,
  "ai-regulation": Scale,
  "ai-safety": ShieldCheck,
  "open-source-ai": GitBranch,
  latest: Newspaper,
};

export const CategoryIcon = ({ slug, size = 12, className = "" }) => {
  const Icon = CATEGORY_ICONS[slug] || Newspaper;
  return <Icon size={size} className={className} aria-hidden="true" />;
};

export function CategoryTag({ slug = "ai-companies", plain = false }) {
  const { catName } = useI18n();
  return (
    <span
      data-testid={`category-tag-${slug}`}
      className={`inline-flex items-center gap-1 font-mono uppercase tracking-wider text-violet-700 ${plain ? "text-[9px]" : "text-[10px] bg-violet-50 px-2 py-0.5 rounded"}`}
    >
      <CategoryIcon slug={slug} size={plain ? 11 : 12} className="shrink-0" />
      {catName(slug)}
    </span>
  );
}
